export default "__VITE_ASSET__TtOvVlBO__"